import { render, staticRenderFns } from "./SimplifiedOnboarding.vue?vue&type=template&id=617af472"
import script from "./SimplifiedOnboarding.vue?vue&type=script&lang=js"
export * from "./SimplifiedOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports